var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaretDownGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29158 10.2929C8.10477 10.4818 8 10.7368 8 11.0024C8 11.2681 8.10477 11.523 8.29158 11.7119L11.2306 14.6769C11.4486 14.8919 11.7306 14.9989 12.0096 14.9989C12.2886 14.9989 12.5656 14.8919 12.7786 14.6769L15.7086 11.7219C15.8951 11.5329 15.9998 11.278 15.9998 11.0124C15.9998 10.7469 15.8951 10.492 15.7086 10.3029C15.6167 10.2098 15.5073 10.1358 15.3866 10.0853C15.2659 10.0347 15.1364 10.0087 15.0056 10.0087C14.8748 10.0087 14.7452 10.0347 14.6245 10.0853C14.5039 10.1358 14.3944 10.2098 14.3026 10.3029L12.0046 12.6199L9.69758 10.2929C9.60554 10.2001 9.49604 10.1264 9.37538 10.0762C9.25472 10.0259 9.1253 10 8.99458 10C8.86386 10 8.73444 10.0259 8.61378 10.0762C8.49312 10.1264 8.38362 10.2001 8.29158 10.2929Z",
    fill: "#42526E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownGrey);
export default __webpack_public_path__ + "static/media/caretDownGrey.86b982a1.svg";
export { ForwardRef as ReactComponent };